import { Injectable } from '@angular/core';
import { Actions, Effect } from '@ngrx/effects';
import { Observable } from 'rxjs/Observable';
import { SnackbarOpen } from '../actions';
import { ActionWithPayload, AppState } from "@store/reducers";
import { UserService } from "@services/user.service";
import { Router } from "@angular/router";
import { Store } from "@ngrx/store";
import {EDIT_USER} from "@store/actions";
import {EditUserFail, LOAD_USER_CARDS, LoadUserCards, LoadUserCardsSuccess} from "@store/actions/profile.action";
import 'rxjs/add/operator/map';

@Injectable()
export class ProfileEffects {

  constructor(
    private actions$: Actions,
    private userService: UserService,
    private router: Router,
    private store: Store<AppState>,
  ) {}

  @Effect() editUserSettings: Observable<any> = this.actions$
    .ofType(EDIT_USER)
    .switchMap((action: ActionWithPayload<any>) => {
      return this.userService.setUser(action.payload)
        .map(() => {
          return new SnackbarOpen({
            data: {
              message: 'Your account settings was successfully saved.',
              error: false,
            },
          })
        })
        .catch(() => {
          this.store.dispatch(new SnackbarOpen({
            data: {
              message: 'Your account settings could not be saved.',
              error: true,
            },
          }));
          return Observable.of(new EditUserFail());
        })
    });

  @Effect() loadUserCards: Observable<ActionWithPayload<any>> = this.actions$
    .ofType(LOAD_USER_CARDS)
    .switchMap((action: ActionWithPayload<any>) => {
      return this.userService.getCards()
        .map(({data: cards}) => new LoadUserCardsSuccess({cards}))
    });
}



// WEBPACK FOOTER //
// ./src/app/store/effects/profile.effect.ts